export function scrollToTop() {
    $(".scroll-to-top").click(function (event) {
        event.preventDefault();
        $("html, body").animate({scrollTop:0}, 1000);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scroll-to-top.js